import {createSelector} from '@reduxjs/toolkit';

const global = (state: any) => state.global;

export const selectGlobal = createSelector(
  global,
  globalSelect => globalSelect,
);
